import React, { useState } from 'react';
import Nav from '../../../userservice/common/component/Nav/Nav';
import MainContainer from '../../../userservice/common/component/MainContainer';
import { useHistory } from 'react-router-dom';
import AppComponent from '../../components/AppsComponent/AppComponent';
import cx from 'classnames';
import styles from './OnboardingDownload.module.scss';

export const OnboardingDownload = () => {
  const history = useHistory();

  return (
    <>
      <Nav />
      <MainContainer className="content-padding play-bg">
        <div>
          <div>
            <div className={cx(styles.onboarding)}>
              <AppComponent handleNextStep={() => history.push('/eg/dashboard')} disableNext={false} loading={false} />
            </div>
          </div>
        </div>
      </MainContainer>
    </>
  );
};
